module.exports = __webpack_public_path__ + "static/media/marketing_use_case_2.3bccf967.svg";